var React = require('react');

function IconLeadPending (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Zm0-3.294a8.706 8.706 0 1 0 0-17.412 8.706 8.706 0 0 0 0 17.412Z"}));
}

IconLeadPending.defaultProps = {"fill":"currentColor","viewBox":"0 0 24 24"};

module.exports = IconLeadPending;

IconLeadPending.default = IconLeadPending;
